const ActionButtonsSection = ({ saved, isFromDashboard }) => {
  if (isFromDashboard || !saved) return null;

  return (
    <div className="flex justify-center items-center pb-8">
      <span className="text-green-600 text-sm font-medium flex items-center gap-1">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
        Trip Saved to Dashboard
      </span>
    </div>
  );
};

export default ActionButtonsSection;
